import { render } from "./PhrozenVerifiedItem.vue?vue&type=template&id=f0fe4eee"
import script from "./PhrozenVerifiedItem.vue?vue&type=script&lang=js"
export * from "./PhrozenVerifiedItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__